import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "GlobalCarRelatedProducts" })
export default class GlobalCarRelatedProducts extends Vue {
    public localizer: any = Localizer;
    public relatedProducts: any[] = [];

    @Prop() readonly bremboCode: string;
    @Prop() readonly productType: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getRelatedProduct();
    }

    public async getRelatedProduct() {
        try {
            const response = (await Axios.post(this.routes.CatalogueGlobalCarDetail_GetRelatedProducts, { bremboCode: this.bremboCode, productType: this.productType })).data;
            this.relatedProducts = response;
        } catch (error) {
            this.relatedProducts = [];
        }
    }

    public getProductLabel(product: any): string {
        let label = null;
        if (product.productType === "Disc") {
            label = this.localizer.get("Catalogue.Common.List_Disc");
        } else if (product.productType === "Pad") {
            label = this.localizer.get("Catalogue.Common.List_Pad");
        } else if (product.productType === "Caliper" && product.isXStyle) {
            label = this.localizer.get("Catalogue.Common.List_Caliper_XStyle");
        } else if (product.productType === "Caliper" && !product.isXStyle) {
            label = this.localizer.get("Catalogue.Common.List_Caliper");
        } else if (product.productType === "UpgradeKit") {
            label = this.localizer.get("Catalogue.Common.List_ProductUpgradeKit_Title");
            if (product.bremboCode.slice(-1) === "S") {
                label = this.localizer.get("Catalogue.Common.List_ProductUpgradeKitS_Title");
            } else if (product.bremboCode.slice(-1) === "R") {
                label = this.localizer.get("Catalogue.Common.List_ProductUpgradeKitR_Title");
            }
        } else if (product.productType === "DiscPadKit") {
            switch (product.productSubType) {
                case "EVKit":
                    label = this.localizer.get("Catalogue.Common.List_Beyond_EVKit");
                    break;
                case "GreenanceKit":
                    label = this.localizer.get("Catalogue.Common.List_Beyond_GreenanceKit");
                    break;
            }
        }

        if (product.productType === "Disc") {
            if (product.isEv) {
                label = this.localizer.get("Catalogue.Common.List_EVKit_Disc");
            } else if (product.isGreenance) {
                label = this.localizer.get("Catalogue.Common.List_Beyond_GreenanceDisc");
            } else if (product.isBremboMax) {
                label += " " + this.localizer.get("Catalogue.Common.Max");
            } else if (product.isBremboXtra) {
                label += " " + this.localizer.get("Catalogue.Common.Xtra");
            } else if (product.isSport) {
                label += " " + this.localizer.get("Catalogue.Common.Sport");
            } else if (product.isLightWeight) {
                label += " " + this.localizer.get("Catalogue.Common.LightWeight");
            } else if (product.isDualCast) {
                label += " " + this.localizer.get("Catalogue.Common.DualCast");
            } else if (product.isComposite) {
                label += " " + this.localizer.get("Catalogue.Common.Composite");
            } else if (product.isFloating) {
                label += " " + this.localizer.get("Catalogue.Common.Floating");
            } else if (product.isCoCast) {
                label += " " + this.localizer.get("Catalogue.Common.CoCast");
            } else if (product.isPainted && !product.isBremboMax && !product.isBremboXtra) {
                label += " " + this.localizer.get("Catalogue.Common.Painted");
            }
        } else if (product.productType === "Pad") {
            if (product.isEv) {
                label = this.localizer.get("Catalogue.Common.List_Beyond_EVPad");
            } else if (product.isGreenance) {
                label = this.localizer.get("Catalogue.Common.List_GreenancePad");
            } else if (product.isBremboXtra) {
                label += " " + this.localizer.get("Catalogue.Common.Xtra");
            } else if (product.isNAO) {
                label += " " + this.localizer.get("Catalogue.Common.PrimeCeramic");
            } else if (product.isXtraCeramic) {
                label += " " + this.localizer.get("Catalogue.Common.XtraCeramic");
            }
        }

        return label;
    }

    public getDataLine(product: any): any {
        let dataLine = { dataType: null, dataTitle: null };

        if (product.productType === "Disc") {
            dataLine.dataType = "Prime";
            dataLine.dataTitle = "Prime Line";
            if (product.isBremboMax || product.isBremboXtra || product.isBearingKit) {
                dataLine.dataType = "Xtra";
                dataLine.dataTitle = "Xtra Line";
            } else if (product.isSport) {
                dataLine.dataType = "Upgrade";
                dataLine.dataTitle = "Upgrade Line";
            }
        } else if (product.productType === "Pad") {
            dataLine.dataType = "Prime";
            dataLine.dataTitle = "Prime Line";
            if (product.isEv || product.isGreenance) {
                dataLine.dataType = "BeyondLine";
                dataLine.dataTitle = "Beyond Line";
            } else if (product.isBremboXtra || product.isNAO || product.isXtraCeramic) {
                dataLine.dataType = "Xtra";
                dataLine.dataTitle = "Xtra Line";
            }
        } else if (product.productType === "DiscPadKit") {
            dataLine.dataType = "BeyondLine";
            dataLine.dataTitle = "Beyond Line";
        } else if (product.productType === "UpgradeKit") {
            dataLine.dataType = "Upgrade";
            dataLine.dataTitle = "Upgrade Line";
        }

        return dataLine;
    }
}